

export const RADIOGROUP= "RADIOGROUP";
export const INPUT = "INPUT";
export const DEFAULT_LANGUAGE = "en";

// Grouped constants
export const ERROR_MESSAGES = {
  NETWORK_ERROR: "Network error, please try again.",
  UNAUTHORIZED: "You are not authorized to access this resource.",
};

export const STATUS_CODES = {
  SUCCESS: 200,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};
